import { api } from '@/lib/api'
import { Agency } from '@/types'

export interface AgencyStats {
  totalCounselors: number
  activeCounselors: number
  totalStudents: number
  activeStudents: number
  totalSessions: number
  completedSessions: number
  totalRevenue: number
  monthlyRevenue: number
  averageRating: number
  responseTime: number
}

export interface CounselorPerformance {
  counselorId: string
  counselorName: string
  firstName: string
  lastName: string
  email: string
  totalSessions: number
  completedSessions: number
  averageRating: number
  totalRevenue: number
  responseTime: number
  studentCount: number
  specialization: string
  isAvailable: boolean
  joinedDate: string
}

export interface AgencyDashboardData {
  agency: Agency
  stats: AgencyStats
  counselorPerformance: CounselorPerformance[]
  recentActivity: any[]
  goals: {
    revenueTarget: number
    sessionsTarget: number
    studentEngagementTarget: number
  }
}

// Get current user's agency
export const getMyAgency = async (): Promise<Agency> => {
  return api.get<Agency>('/agencies/my-agency')
}

// Get agency dashboard data
export const getAgencyDashboard = async (): Promise<AgencyDashboardData> => {
  return api.get<AgencyDashboardData>('/agencies/dashboard')
}

// Get agency counselors with performance data
export const getAgencyCounselors = async (
  agencyId: string,
  params?: {
    search?: string
    specializations?: string[]
    minExperience?: number
    languages?: string[]
    availability?: boolean
    page?: number
    limit?: number
    orderBy?: 'name' | 'rating' | 'sessions' | 'revenue'
    orderDirection?: 'asc' | 'desc'
  }
): Promise<{ counselors: CounselorPerformance[], total: number }> => {
  return api.get(`/agencies/${agencyId}/counselors`, params)
}

// Get agency statistics
export const getAgencyStats = async (
  agencyId: string,
  timeframe?: 'week' | 'month' | 'quarter' | 'year'
): Promise<AgencyStats> => {
  return api.get(`/agencies/${agencyId}/stats`, { timeframe })
}